import {Text} from "@pg-design/text-module";
import {areaFormat} from "@pg-mono/string-utils";

import {PROPERTY_CARD_DETAIL_OVERVIEW_CONTENT} from "../../constants/property_card_detail_overview_content";
import {IPropertyDetailDTO} from "../../types/property/IPropertyDetailDTO";
import {
    getPropertyCardDetailOverviewLocationName,
    getPropertyCardDetailOverviewOfferTypeName,
    getPropertyCardDetailOverviewRoomsLabel
} from "../../utils/property_card_detail_overview_utils";

import * as styles from "./HomematchPropertyCardDetailOverviewSummary.module.css";

interface IProps {
    property: IPropertyDetailDTO;
}

export const HomematchPropertyCardDetailOverviewSummary = (props: IProps) => {
    const {property} = props;

    const area = areaFormat(property.area, {precision: 2});
    const location = getPropertyCardDetailOverviewLocationName(property);
    const offerTypeName = getPropertyCardDetailOverviewOfferTypeName(property);
    const roomsLabel = getPropertyCardDetailOverviewRoomsLabel(property);

    return (
        <Text as="p" className={styles.summary} color="var(--colors-secondary)" variant="body_copy_2">
            <strong>
                {roomsLabel} {offerTypeName}
            </strong>{" "}
            {PROPERTY_CARD_DETAIL_OVERVIEW_CONTENT.AREA_PREFIX} <strong>{area}</strong> <strong>{location}</strong>.
        </Text>
    );
};
import {Text} from "@pg-design/text-module";
import {areaFormat} from "@pg-mono/string-utils";

import {PROPERTY_CARD_DETAIL_OVERVIEW_CONTENT} from "../../constants/property_card_detail_overview_content";
import {IPropertyDetailDTO} from "../../types/property/IPropertyDetailDTO";
import {
    getPropertyCardDetailOverviewLocationName,
    getPropertyCardDetailOverviewOfferTypeName,
    getPropertyCardDetailOverviewRoomsLabel
} from "../../utils/property_card_detail_overview_utils";

import * as styles from "./HomematchPropertyCardDetailOverviewSummary.module.css";

interface IProps {
    property: IPropertyDetailDTO;
}

export const HomematchPropertyCardDetailOverviewSummary = (props: IProps) => {
    const {property} = props;

    const area = areaFormat(property.area, {precision: 2});
    const location = getPropertyCardDetailOverviewLocationName(property);
    const offerTypeName = getPropertyCardDetailOverviewOfferTypeName(property);
    const roomsLabel = getPropertyCardDetailOverviewRoomsLabel(property);

    return (
        <Text as="p" className={styles.summary} color="var(--colors-secondary)" variant="body_copy_2">
            <strong>
                {roomsLabel} {offerTypeName}
            </strong>{" "}
            {PROPERTY_CARD_DETAIL_OVERVIEW_CONTENT.AREA_PREFIX} <strong>{area}</strong> <strong>{location}</strong>.
        </Text>
    );
};
